export default __webpack_public_path__ + "static/media/Shawn-bf42c7b909dae3111d18a21870ee6ca5.0d373888.png";